/**
 * Конвектирует урл в абсолютный
 * @param relativeUrl {string}
 * @returns {string}
 */
const toAbsolute = (relativeUrl) => {
  return new URL(relativeUrl, window.location.origin).href;
};

/**
 * Конвектирует абсолютный в relative
 * @param absoluteUrl
 * @returns {string}
 */
const toRelative = (absoluteUrl) => {
  const URL_ = new URL(absoluteUrl, window.location.origin);
  return URL_.pathname + URL_.search + URL_.hash;
};

export default {
  url: {
    toAbsolute,
    toRelative,
  }
};



// WEBPACK FOOTER //
// ./daily/assets/common/core/helpers.js